import * as AccordionRadix from "@radix-ui/react-accordion";
import { ChevronDownIcon } from "@radix-ui/react-icons";
import React from "react";
import styles from "./styles.module.css";

interface AccordionProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
  initiallyOpen?: boolean;
}

const Accordion = (props: AccordionProps) => {
  return (
    <AccordionRadix.Root
      className={styles.accordionRoot}
      type="single"
      defaultValue={props.initiallyOpen ? "item-1" : undefined}
      collapsible
    >
      <AccordionRadix.Item className={styles.accordionItem} value="item-1">
        <AccordionRadix.Header className={styles.accordionHeader}>
          <AccordionRadix.Trigger className={styles.accordionTrigger}>
            {props.title}
            <ChevronDownIcon className={styles.accordionChevron} aria-hidden />
          </AccordionRadix.Trigger>
        </AccordionRadix.Header>

        <AccordionRadix.Content className={styles.accordionContent}>{props.children}</AccordionRadix.Content>
      </AccordionRadix.Item>
    </AccordionRadix.Root>
  );
};

export default Accordion;
